<template>
    <div>
        <div class="rounded position-relative pl-2 pr-2 pt-2 mb-4"
             :style="{background:  reply.stance_colour}">
            <a class="help-btn" data-toggle="modal" data-target="#stanceHelpModal"><img
                    src="/static/images/help.svg" alt="Explanation of stance classification"
                    title="Explanation of stance classification"></a>
            <div>
                <blockquote class="twitter-tweet" data-conversation="none" data-lang="en">



                    <Tweet :id="reply.id_str" :options="{conversation: 'none'}">
                        <custom-tweet-display :tweet="reply"></custom-tweet-display>


                    </Tweet>
                </blockquote>

            </div>

            <div class="mr-1"
                 :style="{background: 'linear-gradient('+reply.stance_colour+' , white 30%)',  display: 'inline-block'}">
                <div class="pl-2 pr-2 pt-2 ">
                    <template v-if="reply.auto_stance_available">
                        <img src="/static/images/robot.svg"
                             alt="Our algorithm says the stance is "
                             style="height: 2em;" title="Our algorithm says the stance is "/> {{reply.stance_text}}
                    </template>
                    <template v-else>
                        <img src="/static/images/robot.svg" alt="Our algorithm says the stance is "
                             style="height: 2em;" title="Our algorithm says the stance is "/> <span
                            class="badge badge-secondary"
                            :title="reply.stance_badge_text">{{ reply.stance_text }}</span>
                    </template>
                </div>
            </div>
            <div class="pl-2 pr-2 pt-2 mr-1" style="background: white; display: inline-block;">
                <div>
                    <img src="/static/images/opinion.svg" alt="Users voted for the following stance "
                         title="Users voted for the following stance " class="mr-1" style="height: 2em;"/>
                    <a href="#" class="stancevote-btn supportstance-btn" data-stance="support"
                       data-toggle="tooltip" data-placement="top"
                       :title="supportTitle" @click.prevent="voteForStance('support')">{{supportNumVotes}}</a>
                    <a href="#" class="stancevote-btn denystance-btn" data-stance="deny"
                       data-toggle="tooltip" data-placement="top"
                       :title="denyTitle" @click.prevent="voteForStance('deny')">{{denyNumVotes}}</a>
                    <a href="#" class="stancevote-btn commentstance-btn" data-stance="comment"
                       data-toggle="tooltip" data-placement="top"
                       :title="commentTitle" @click.prevent="voteForStance('comment')">{{commentNumVotes}}</a>
                    <a href="#" class="stancevote-btn questionstance-btn" data-stance="question"
                       data-toggle="tooltip" data-placement="top"
                       :title="questionTitle" @click.prevent="voteForStance('question')">{{questionNumVotes}}</a>
                </div>
            </div>

            <div class="pl-2 pr-2 pt-2 mr-1" style="background: white; display: inline-block;">
                <div>
                    <span v-if="this.reply.lang != 'und'">Language: {{ this.reply.lang }}</span>
                </div>
            </div>                    


        </div>
        <template v-if="reply.replies && reply.replies.length > 0 && displaySubreplies">
            <div v-for="subReply in reply.replies" class="subtweet-container">
                <tweet-reply :reply="subReply" :key="subReply.id_str"></tweet-reply>
            </div>
        </template>

    </div>

</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import CustomTweetDisplay from "./CustomTweetDisplay";

    export default {
        name: "TweetReply",
        components: {CustomTweetDisplay},
        props: {
            reply: {
                type: Object,
                default: null
            },
            displaySubreplies: {
                type: Boolean,
                default: true
            }

        },
        computed: {
            ...mapState(["user","siteConfig"]),
            supportTitle() {
                if (!this.user.isAuthenticated) {
                    return "Log in to vote for this stance!";
                }else if (this.siteConfig.showOtherUserVotes) {
                    return "Support " + this.reply.support_votes + " vote(s). Click to vote for this stance!";
                }else{
                    return "Support. Click to vote for this stance!"
                }
            },
            supportNumVotes() {
                if (this.siteConfig.showOtherUserVotes) {
                    return this.reply.support_votes;
                } else {
                    return '-'
                }
            },
            denyTitle() {
                if (!this.user.isAuthenticated) {
                    return "Log in to vote for this stance!";
                }else if (this.siteConfig.showOtherUserVotes) {
                    return "Deny " + this.reply.deny_votes + " vote(s). Click to vote for this stance!";
                }else{
                    return "Deny. Click to vote for this stance!"
                }
            },
            denyNumVotes() {
                if (this.siteConfig.showOtherUserVotes) {
                    return this.reply.deny_votes;
                } else {
                    return '-'
                }
            },
            commentTitle() {
                if (!this.user.isAuthenticated) {
                    return "Log in to vote for this stance!";
                }else if (this.siteConfig.showOtherUserVotes) {
                    return "Comment " + this.reply.comment_votes + " vote(s). Click to vote for this stance!";
                }else{
                    return "Comment. Click to vote for this stance!"
                }
            },
            commentNumVotes() {
                if (this.siteConfig.showOtherUserVotes) {
                    return this.reply.comment_votes;
                } else {
                    return '-'
                }
            },
            questionTitle() {
                if (!this.user.isAuthenticated) {
                    return "Log in to vote for this stance!";
                }else if (this.siteConfig.showOtherUserVotes) {
                    return "Question " + this.reply.question_votes + " vote(s). Click to vote for this stance!";
                }else{
                    return "Question. Click to vote for this stance!"
                }
            },
            questionNumVotes() {
                if (this.siteConfig.showOtherUserVotes) {
                    return this.reply.question_votes;
                } else {
                    return '-'
                }
            },

        },
        methods: {
            ...mapActions(["addStanceVote"]),
            voteForStance(stance) {
                this.addStanceVote({tweetId: this.reply.id_str, stance: stance});
            }
        }

    }
</script>

<style scoped>

</style>
